import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from '@americanexpress/dls-react';
import { IconChevronRight } from '@americanexpress/dls-icons';
import { useModal } from '@/context/modalContext';
import { useAnalyticsContext } from '@/context/analyticsContext';
import { useRouteParams } from '@/context/routeParamsContext';
import { useLoungePrioritisedAccessRules } from '@/hooks/loungesHooks/loungesHelperHooks';
import { usePriorityPassEnrollmentDetails } from '@/hooks/priorityPassHooks/priorityPassHelperHooks';
import { isPriorityPassLounge } from '@/helpers/utils';

const PolicyButton = ({ id, heading, modalType, icon }) => {
  const { setModalName } = useModal();
  const { customTrack } = useAnalyticsContext();
  const { loungeId } = useRouteParams();
  const accessRules = useLoungePrioritisedAccessRules(loungeId);
  const {
    enabled: isPriorityPassEnabled,
    badge: priorityPassBadgeStatus,
    content: priorityPassContent,
  } = usePriorityPassEnrollmentDetails();
  const isPriorityPass =
    isPriorityPassEnabled && isPriorityPassLounge(accessRules);

  return (
    <button
      id={id}
      type="button"
      className="tw-w-full tw-px-2 tw-py-4 focus_tw-rounded-2xl"
      onClick={(e) => {
        customTrack({
          event: e,
          detail: id,
        });
        setModalName(modalType);
      }}
    >
      <div className="tw-flex tw-gap-2">
        {icon}
        <p className="tw-heading-xs-bold">{heading}</p>
        <span className="tw-ml-auto tw-flex tw-items-center tw-gap-2">
          {id.includes('access-policy') && isPriorityPass && (
            <Badge
              className="tw-body-xs-bold"
              status={priorityPassBadgeStatus}
              size="large"
              type="text"
            >
              {priorityPassContent?.title}
            </Badge>
          )}
          <IconChevronRight
            size="sm"
            isFilled={true}
            color="tw-blue-bright-600"
          />
        </span>
      </div>
    </button>
  );
};

PolicyButton.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  modalType: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
};

export default PolicyButton;
